// extracted by mini-css-extract-plugin
export var media = "media-module--media--FV09b";
export var media_svg = "media-module--media_svg--W-73B";
export var media__image = "media-module--media__image--2DLgD";
export var media__player = "media-module--media__player--Mar2V";
export var media__playerWrapper = "media-module--media__player-wrapper--7hMSL";
export var media__playerWrapper_big = "media-module--media__player-wrapper_big--sdFdt";